<template>
    <div id="adset-preview">
        <div class="row page-title">
            <div class="col-md-12">
                <h1>Ad Set Preview</h1>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="wrapper">
                    <div class="row adset-summary">
                        <div class="col-md-12">
                            <h2>Ad Set Summary</h2>
                        </div>
                        <div class="col-md-12" v-show="adSet.id > 0" v-cloak>
                            <mortgage-campaign-adset-preview-summary
                                :adSet="adSet"
                                :dimensions="dimensions"
                            ></mortgage-campaign-adset-preview-summary>
                        </div>
                        <div class="col-md-12 text-center" v-show="adSet.id == null">
                            <i class="fa fa-spinner fa-spin inner-loading"></i>
                        </div>
                    </div>

                    <div class="row">
                        <mortgage-campaign-adset-preview-creative :advertiser="advertiser"></mortgage-campaign-adset-preview-creative>
                    </div>
                </div>
            </div>
        </div>
        <div class="row buttons">
            <div class="col-md-5 pull-right m-b-lg">
                <a :href="dashboardUrl" class="btn btn-block --gray --gray-border">CONTINUE TO DASHBOARD</a>
            </div>
        </div>
    </div>
</template>

<style lang="scss">
    .wrapper {
        background-color: #ffffff;
        border: 1px solid #dedede;
        box-shadow: 0 1px 0 #a7a8af;
        -webkit-box-shadow: 0 1px 0 #a7a8af;
        -moz-box-shadow: 0 1px 0 #a7a8af;
        padding: 3rem;
        margin-bottom: 16px;
    }
</style>

<script>
import {slugify} from '../../../utils.js';
export default {
    props: ['campaign', 'adSet', 'advertiser','dimensions'],
    computed: {
        dashboardUrl() {
            return route(`campaigns.${slugify(this.campaign.product_category.name)}.index`);
        },
    }
}
</script>
